import _ from "lodash";
import { DatePicker } from "@mantine/dates";
import moment from "moment";

import React from "react";
import { Text } from "@mantine/core";
import useDeepCompareEffect from "../hooks/useDeepCompareEffect";

const DateOffPicker = ({
  form: mainForm,
  name,
  label,
  relatedField,
  daysOff = 1,
  editable = false,
  value,
  onChange,
  ...props
}) => {
  const fieldValue = value ?? _.get(mainForm.values, name);
  const relatedFieldValue = _.get(mainForm.values, relatedField);

  useDeepCompareEffect(() => {
    const d = relatedFieldValue
      ? moment(relatedFieldValue).add(daysOff, "days")
      : null;
    return mainForm.setFieldValue(name, d ? d.toISOString() : null);
  }, [relatedFieldValue]);

  if (editable) {
    return <DatePicker {...props} label={label} value={fieldValue} onChange={onChange} />;
  }

  return (
    <>
      {fieldValue && (
        <>
          <Text size={14}> {label}</Text>
          <Text size={14} weight={700}>
            {fieldValue ? moment(fieldValue).format("LL") : "----"}
          </Text>
        </>
      )}
    </>
  );
};

export default DateOffPicker;
